import { Flex, Heading, Text } from "@chakra-ui/react";
import { Button } from "@radix-ui/themes";
import { NavLink } from "react-router-dom";
import useAppLogo from "./assets/use-app-icon.png";
import { routes } from "./routes";
import { useQRCodeScanner } from "./shared/hooks/use-qr-code-scanner";

function AppPage() {
  const { scanQRCode, isLoading } = useQRCodeScanner();

  return (
    <Flex gap="112px" direction="column" align="center">
      <Flex gap="32px" direction="column" align="center" textAlign="center">
        <div>
          <img src={useAppLogo} className="shared-logo" alt="Use logo" />
        </div>
        <Heading as="h1">use Group</Heading>
        <Text fontSize="large" color="gray.600" maxW="300px" my="4">
          Willkommen!
          <br />
          Scannen Sie den QR-Code des Fahrrads.
        </Text>
        <Button onClick={() => void scanQRCode()} size="4" loading={isLoading}>
          QR-Code scannen
        </Button>
        <Button size="3" variant="soft" asChild mt="16px">
          <NavLink to={routes.map}>Karte</NavLink>
        </Button>
        <Button size="3" variant="soft" asChild mt="16px">
          <NavLink to={routes.bookings.my}>Meine Buchungen</NavLink>
        </Button>
      </Flex>
    </Flex>
  );
}

export default AppPage;
